/** @jsx jsx */
import { jsx } from "theme-ui";
import PortableTextComponent from "./portableTextComponents";
import { PortableText } from "@portabletext/react";
import Container from "../container";
import LinkResolve from "./linkResolve";
import "../../scss/component/newsBlock.scss";
import { Splide, SplideSlide } from "@splidejs/react-splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";
import "@splidejs/react-splide/css/core";

const NewsBlock = ({ value }) => {
  return (
    <div
      id={value.id ? value.id : ""}
      sx={{
        background: value?.background == "white" ? "white" : "grayBG",
        padding: value?.title || value?.link || value?.body ? "100px 0px" : "80px 0px 70px 0px"
      }}
    >
      <Container>
        <div
          sx={{
            display: "flex",
            justifyContent: "flex-start",
            flexWrap: "wrap",
          }}
        >
          <div
            sx={{
              width: ["100%", "100%", "50%"],
            }}
          >
            <h2
              sx={{
                fontSize: ["2rem", "2rem", "3rem"],
                margin: "0px",
              }}
            >
              {value.title}
            </h2>
            {value.link && (
              <div
                sx={{
                  a: {
                    variant: "buttons.primaryBlue",
                    marginTop: "15px",
                    display: "inline-block",
                  },
                }}
              >
                <LinkResolve
                  link={value.link.link}
                  children={value.link.label}
                  target="_self"
                  ariaLabel={value.link.link.arialLabel}
                />
              </div>
            )}
          </div>
          <div
            sx={{
              width: ["100%", "100%", "50%"],
              maxWidth: ["100%", "100%", "420px"],
              color: "textGray",
              fontSize: "body",
            }}
          >
            <PortableText
              value={value.body}
              components={PortableTextComponent}
            />
          </div>
        </div>
      </Container>
      <div
        className="news-slide-container"
        sx={{
          marginTop: value?.title || value?.link || value?.body ? "75px" : "0px",
          ".splide__slide": {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          },
        }}
      >
        <Splide
          options={{
            type: "loop",
            drag: "free",
            focus: "center",
            perPage: 3,
            arrows: false,
            pagination: false,
            autoWidth: true,
            gap: 150,
            autoScroll: {
              speed: 2,
              // rewind: false,
            },
          }}
          extensions={{ AutoScroll }}
        >
          {value.logos.map((logo, index) => (
            <SplideSlide key={index}>
              <img src={logo.asset.url} alt={logo.asset.originalFilename.replace(/\.[^/.]+$/, "")} />
            </SplideSlide>
          ))}
        </Splide>
      </div>
    </div>
  );
};

export default NewsBlock;
